import { useRef, useState } from 'react';

//Primereact components
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import { RecordRegisterValidate } from '../../../config/Validate';
import { APP_BASE_URL, REGPREFIX } from '../../../appconfig/Settings';
import { getAllDetailsDirect } from '../../../service/ProductService';
import { DOWNLOADRECORDREGISTER } from '../../../config/ApiConstant';
import { Dropdown } from 'primereact/dropdown';
import AppBreadcrumb from '../../../components/CustomeBreadcrumb/AppBreadcrumb';

export const RecordRegisterReport = () => {
    document.title = 'Record Register | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    //Loading/Page Loading
    const [errors, setErrors] = useState<any>({});
    const [showLoading, setShowLoading] = useState<boolean>(false);

    const [selectedRegPrefix, setSelectedRegPrefix] = useState<any>(null);

    // Global search
    const leftToolbarTemplate = () => {
        return (
            <>
                <div>
                    <label htmlFor="prefix">Registration Prefix</label>
                    <div className="input-effect-div mt-1">
                        <Dropdown
                            value={selectedRegPrefix}
                            name="application"
                            options={REGPREFIX}
                            filter
                            optionLabel="name"
                            placeholder="Select Option"
                            onChange={(e) => setSelectedRegPrefix(e.value)}
                            className={errors['application'] && 'p-invalid '}
                            style={{ minWidth: '300px' }}
                        />
                    </div>
                    <small className="p-invalid-txt">{errors['application']}</small>
                </div>

                <Button label="Download" onClick={() => getRecordRegisterList()} loading={showLoading} className="ml-3 mt-4"></Button>
            </>
        );
    };

    // getRecordRegisterListList
    const getRecordRegisterList = async () => {
        try {
            const { errors, isError } = RecordRegisterValidate(selectedRegPrefix);
            setErrors(errors);
            if (!isError) {
                setShowLoading(true);

                const response = await getAllDetailsDirect(DOWNLOADRECORDREGISTER + '?option=' + selectedRegPrefix?.code);
                if (response?.success) {
                    setShowLoading(false);
                    //CSV Download
                    const link = document.createElement('a');
                    link.href = APP_BASE_URL + '/csv/record_register.csv';
                    link.target = '_blank';
                    document.body.appendChild(link);
                    link.click();
                }
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setShowLoading(false);

                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
            }
        }
    };

    return (
        <>
            <AppBreadcrumb currentMenu={'Reports'} pageName={'Record Register'} pageTitle={'Record Register'} goToPage={true} />

            <Toast ref={toast} />
            <div className="grid crud-demo mt-2 pci-register">
                <div className="col-12">
                    <div className="card">
                        <Toolbar left={leftToolbarTemplate}></Toolbar>
                    </div>
                </div>
            </div>
        </>
    );
};
